module.exports = __webpack_public_path__ + "static/media/Joseph C.5c3e4e30.png";